import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './components/Home';
import OperatorView from './components/OperatorView';
import ExpertView from './components/ExpertView';
import LandingPage from './components/LandingPage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/Home" element={<Home />} />
      <Route path="/operator/:sessionId" element={<OperatorView />} />
      <Route path="/expert/:sessionId" element={<ExpertView />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default App;